// extracted by mini-css-extract-plugin
export default {"imageContainer":"I3-z","summaryPar":"J3-z","ratingCategories":"K3-z","reviewerInfo":"L3-z","reviewTypes":"M3-z","expanded":"N3-z"};